import { useTranslation } from "react-i18next";

const RecaptchaNotice = () => {
  const { t } = useTranslation();
  return (
    <p
      style={{ fontSize: "12px", color: "#6b7280" }}
      className="text-center w-2/3 mx-auto mt-3"
    >
      {t("captcha")}{" "}
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        {t("Privacy Policy")}
      </a>{" "}
      {t("and")}{" "}
      <a
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        {t("Terms of Service")}
      </a>
      .
    </p>
  );
};

export default RecaptchaNotice;
